var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-header"
  }, [_c('Menu', {
    attrs: {
      "mode": "horizontal",
      "active-name": _vm.$route.path.split('/')[1]
    },
    on: {
      "on-select": _vm.selectMenu
    }
  }, [_c('div', {
    staticClass: "navicon-con",
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "14px",
      "position": "relative"
    }
  }, [(_vm.sidebar) ? _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "position": "absolute",
      "left": "14px",
      "top": "50%",
      "transform": "translate(-50%,4%)"
    },
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_c('svg-icon', {
    staticStyle: {
      "color": "#495060",
      "font-size": "22px"
    },
    attrs: {
      "icon-class": "default"
    }
  })], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "position": "absolute",
      "left": "14px",
      "top": "50%",
      "transform": "translate(-50%,4%)"
    },
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_c('svg-icon', {
    staticStyle: {
      "color": "#495060",
      "font-size": "22px"
    },
    attrs: {
      "icon-class": "sq"
    }
  })], 1)]), _vm._v(" "), _c('breadcrumbNav'), _vm._v(" "), _c('div', {
    staticClass: "layout-nav"
  }, [_c('div', {
    staticClass: "main-header-operate"
  }, [_c('div', {
    staticClass: "header-avator-con"
  }, [_c('div', {
    staticClass: "user-dropdown-menu-con",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('Row', {
    staticClass: "user-dropdown-innercon",
    attrs: {
      "type": "flex",
      "justify": "end",
      "align": "middle"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "32px",
      "margin-right": "6px"
    },
    attrs: {
      "src": require("../../assets/headPortrait.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "transfer": "",
      "trigger": "click"
    },
    on: {
      "on-click": _vm.handleClickUserDropdown
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "main-user-name"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "name": "loginout",
      "divided": ""
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1)])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-con"
  }, [_c('tagsOpened', {
    attrs: {
      "pageTagsList": _vm.pageTagsList
    },
    on: {
      "on-select": _vm.selectMenu
    }
  })], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-697ed328","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = uHZm
// module chunks = 166